import API from 'services/API';
import { phonePattern } from 'utils/reduxForm/validations';

const regExp = /(\+7)\({0,1}([0-9]{3})\){0,1}(\d{3})-{0,1}(\d{2})-{0,1}(\d{2})/;

export default function getContactInfo() {
  return API.request({
    method: 'GET',
    url: '/profile/profileSettings',
    mapper: function (data) {
      data.phone = data.phone ? convertPhoneNumber(data.phone) : null;
      return data;
    },
  });
}

function convertPhoneNumber(phone) {
  const phoneNumber = phone && phone.startsWith('8') ? phone.replace('8', '+7') : phone;
  if (phoneNumber.match(phonePattern)) {
    return phoneNumber;
  }
  return phoneNumber.replace(regExp, '$1($2)$3-$4-$5');
}
